<div class="text-left global-search-item" [ngClass]="{'stripped': data.odd}" (click)="sendCloseSignal(); sendClearSearchSignal();">
  <a [routerLink]="data.path" [queryParams]="data.queryParams">
  <div class="row m-0">
    <div class="col-3 p-0 d-flex flex-column justify-content-center">
      <img
        alt="{{ data.product?.extra?.gme?.displayName || data.product.name }}"
        class="img-fluid mx-auto d-block"
        *ngIf="data.product.extra.images && data.product.extra.images[0]; else noimage"
        [src]="data.product.extra.images[0].s3Uri | gungImageUrl
          :'type:list'
          :'etag:'+data.product.extra.images[0].s3ETag
        "
      />
      <ng-template #noimage>
        <img
          [src]="'images/no-image.jpg' | gungImageUrl"
          alt="NO IMAGE"
          class="img-fluid mx-auto d-block"
        />
      </ng-template>
    </div>
    <div class="col-9 p-0 pl-2 pr-2 text-truncate">
      <span class="d-block">
        <small
          ><b>{{ data.product?.extra?.gme?.displayId || data.product.id }}</b></small
        >
        <lib-price
          class="float-right"
          *ngIf="!!data.price && (data.product?.['productType'] !== 'concept') && !(data.product?.['assortment'])"
          [price]="data.price"
          type="NET"
          [currency]="data.price.customerNetPrice.currencyCode"
        ></lib-price>
      </span>
      <br />
      <span>{{ data.product?.extra?.gme?.displayName || data.product.name }}</span>
    </div>
  </div>
  </a>
</div>
